import { OneDecimalPlace } from '../../../helpers/Helpers';

export const totalWeeksOfSelectedQuarter = (colArr, quarterIdx: number): number => {
  return colArr[quarterIdx].months.reduce((acc, month) => {
    acc += month.weeks.length;
    return acc;
  }, 0) + 1;
};

export const calculateMeasureTotal = (rowArr, rIdx: number, mIdx: number, measureGroup: string, measureName: string): number => {
  if (measureName === 'ASP Actual $') {
    const qtrLength = rowArr[rIdx].measures[mIdx].quarters.length;
    const measureTotal = calculateMeasureTotalBasedOnQuarterAvg(rowArr[rIdx].measures[mIdx].quarters);

    return Math.round(measureTotal / qtrLength);
  }

  if (measureName === 'Plan ASP $') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');

    if (planSalesIdx === -1 || rowUnitIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const planQuotaUnit = calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[planQuotaIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planSalesIdx].quarters);

    if (planQuotaUnit === 0) {
      return 0;
    }

    return Math.round(planQuotaValue / planQuotaUnit);
  }

  if (measureName === 'Plan ASP Frozen $') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesFrozenIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Sales Plan Frozen $');
    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaFrozenIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U Frozen');

    if (planSalesFrozenIdx === -1 || rowUnitIdx === -1 || planQuotaFrozenIdx === -1) {
      return 0;
    }

    const planQuotaFrozenUnit = calculateActualMeasureTotal(rowArr[rowUnitIdx].measures[planQuotaFrozenIdx].quarters);
    const planQuotaFrozenValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planSalesFrozenIdx].quarters);

    if (planQuotaFrozenUnit === 0) {
      return 0;
    }

    return Math.round(planQuotaFrozenValue / planQuotaFrozenUnit);
  }

  if (measureName === 'PL vs LY U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota U');
    const lyIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals U');

    if (planQuotaIdx === -1 || lyIdx === -1) {
      return 0;
    }

    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lyValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lyIdx].quarters);

    if (lyValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lyValue) / lyValue) * 100);
  }

  if (measureName === 'PL vs LQ U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota U');
    const lqIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals U');

    if (planQuotaIdx === -1 || lqIdx === -1) {
      return 0;
    }

    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lqValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lqIdx].quarters);

    if (lqValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lqValue) / lqValue) * 100);
  }

  if (measureName === 'PL vs LY $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lyIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals $');

    if (planQuotaIdx === -1 || lyIdx === -1) {
      return 0;
    }

    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lyValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lyIdx].quarters);

    if (lyValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lyValue) / lyValue) * 100);
  }

  if (measureName === 'PL vs LQ $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lqIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals $');

    if (planQuotaIdx === -1 || lqIdx === -1) {
      return 0;
    }

    const planQuotaValue = calculateActualMeasureTotal(rowArr[rIdx].measures[planQuotaIdx].quarters);
    const lqValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lqIdx].quarters);

    if (lqValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lqValue) / lqValue) * 100);
  }

  if (measureName === 'Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (planQuotaIdx === -1 || marginIdx === -1) {
      return 0;
    }

    const marginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters);

    if (planQuotaValue === 0) {
      return 0;
    }

    return OneDecimalPlace((marginValue / planQuotaValue) * 100);
  }

  if (measureName === 'Plan Margin Frozen %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan Margin Frozen $');
    const planQuotaFrozenIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Sales Plan Frozen $');

    if (planQuotaFrozenIdx === -1 || marginFrozenIdx === -1) {
      return 0;
    }

    const marginFrozenValue = calculateActualMeasureTotal(rowArr[rIdx].measures[marginFrozenIdx].quarters);
    const planQuotaFrozenValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planQuotaFrozenIdx].quarters);

    if (planQuotaFrozenValue === 0) {
      return 0;
    }

    return OneDecimalPlace((marginFrozenValue / planQuotaFrozenValue) * 100);
  }

  if (measureName === 'LQ Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ Margin $');
    const lqActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');

    if (lqMarginIdx === -1 || lqActualIdx === -1) {
      return 0;
    }

    const lqMarginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lqMarginIdx].quarters);
    const lqActualValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[lqActualIdx].quarters);

    if (lqActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace((lqMarginValue / lqActualValue) * 100);
  }

  if (measureName === 'LY Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY Margin $');
    const lyActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (lyMarginIdx === -1 || lyActualIdx === -1) {
      return 0;
    }

    const lyMarginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lyMarginIdx].quarters);
    const lyActualValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[lyActualIdx].quarters);

    if (lyActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace((lyMarginValue / lyActualValue) * 100);
  }

  if (measureName === 'PL vs LQ Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const marginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters);

    const marginPctValue = Math.round((marginValue / planQuotaValue) * 100);

    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ Margin $');
    const lqActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');

    if (lqMarginIdx === -1 || lqActualIdx === -1) {
      return 0;
    }

    const lqMarginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lqMarginIdx].quarters);
    const lqActualValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[lqActualIdx].quarters);

    const lqMarginPctValue = Math.round((lqMarginValue / lqActualValue) * 100);

    if (planQuotaValue === 0 || lqActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace(marginPctValue - lqMarginPctValue);
  }

  if (measureName === 'PL vs LY Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const marginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[marginIdx].quarters);
    const planQuotaValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters);

    const marginPctValue = Math.round((marginValue / planQuotaValue) * 100);

    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY Margin $');
    const lyActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (lyMarginIdx === -1 || lyActualIdx === -1) {
      return 0;
    }

    const lyMarginValue = calculateActualMeasureTotal(rowArr[rIdx].measures[lyMarginIdx].quarters);
    const lyActualValue = calculateActualMeasureTotal(rowArr[rowIdx].measures[lyActualIdx].quarters);

    const lqMarginPctValue = Math.round((lyMarginValue / lyActualValue) * 100);

    if (planQuotaValue === 0 || lyActualValue === 0) {
      return 0;
    }
    return OneDecimalPlace(marginPctValue - lqMarginPctValue);
  }

  return calculateActualMeasureTotal(rowArr[rIdx].measures[mIdx].quarters);
};

export const calculateActualMeasureTotal = (quarterArr): number => {
  const total = quarterArr.reduce((qInit, quarter) => {
    qInit += quarter.weeks.reduce((wInit, week) => {
      wInit += week.value;
      return wInit;
    }, 0);
    return qInit;
  }, 0);

  return Math.round(total);
};

export const calculateMeasureTotalBasedOnQuarterAvg = (quarterArr): number => {
  const arr: number[] = [];
  quarterArr.reduce((qInit, quarter) => {
    qInit = quarter.weeks.reduce((wInit, week) => {
      wInit += week.value;
      return wInit;
    }, 0);

    arr.push(qInit / quarter.weeks.length);
    return qInit;
  }, 0);

  return arr.reduce((acc, value) => {
    acc += value;
    return acc;
  }, 0);
};

export const calculateQuarterTotal = (rowArr, rIdx: number, mIdx: number, qIdx: number, measureGroup: string, measureName: string): number => {
  if (measureName === 'ASP Actual $') {
    const qtrLength = rowArr[rIdx].measures[mIdx].quarters[qIdx].weeks.length;
    const measureTotal = calculateActualQuarterTotal(rowArr[rIdx].measures[mIdx].quarters[qIdx].weeks);

    return Math.round(measureTotal / qtrLength);
  }

  if (measureName === 'Plan ASP $') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U');

    if (planSalesIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const planQuotaUnit = calculateActualQuarterTotal(rowArr[rowUnitIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planSalesIdx].quarters[qIdx].weeks);

    if (planQuotaUnit === 0) {
      return 0;
    }

    return Math.round(planQuotaValue / planQuotaUnit);
  }

  if (measureName === 'Plan ASP Frozen $') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const planSalesFrozenIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Sales Plan Frozen $');

    const rowUnitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const planQuotaFrozenIdx = rowArr[rowUnitIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota U Frozen');

    if (planSalesFrozenIdx === -1 || planQuotaFrozenIdx === -1) {
      return 0;
    }

    const planQuotaFrozenUnit = calculateActualQuarterTotal(rowArr[rowUnitIdx].measures[planQuotaFrozenIdx].quarters[qIdx].weeks);
    const planQuotaFrozenValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planSalesFrozenIdx].quarters[qIdx].weeks);

    if (planQuotaFrozenUnit === 0) {
      return 0;
    }

    return Math.round(planQuotaFrozenValue / planQuotaFrozenUnit);
  }

  if (measureName === 'PL vs LY U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota U');
    const lyIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals U');

    if (planQuotaIdx === -1 || lyIdx === -1) {
      return 0;
    }

    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const lyValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lyIdx].quarters[qIdx].weeks);

    if (lyValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lyValue) / lyValue) * 100);
  }

  if (measureName === 'PL vs LQ U %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota U');
    const lqIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals U');

    if (planQuotaIdx === -1 || lqIdx === -1) {
      return 0;
    }

    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const lqValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lqIdx].quarters[qIdx].weeks);

    if (lqValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lqValue) / lqValue) * 100);
  }

  if (measureName === 'PL vs LY $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lyIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY - Actuals $');

    if (planQuotaIdx === -1 || lyIdx === -1) {
      return 0;
    }

    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const lyValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lyIdx].quarters[qIdx].weeks);

    if (lyValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lyValue) / lyValue) * 100);
  }

  if (measureName === 'PL vs LQ $ %') {
    const planQuotaIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan / Quota Sales $');
    const lqIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ - Actuals $');

    if (planQuotaIdx === -1 || lqIdx === -1) {
      return 0;
    }

    const planQuotaValue = calculateActualQuarterTotal(rowArr[rIdx].measures[planQuotaIdx].quarters[qIdx].weeks);
    const lqValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lqIdx].quarters[qIdx].weeks);

    if (lqValue === 0) {
      return 0;
    }

    return OneDecimalPlace(((planQuotaValue - lqValue) / lqValue) * 100);
  }

  if (measureName === 'Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (planQuotaIdx === -1 || marginIdx === -1) {
      return 0;
    }

    const marginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters[qIdx].weeks);


    if (planQuotaValue === 0) {
      return 0;
    }
    return OneDecimalPlace((marginValue / planQuotaValue) * 100);
  }

  if (measureName === 'Plan Margin Frozen %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginFrozenIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Plan Margin Frozen $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Sales Plan Frozen $');

    if (planQuotaIdx === -1 || marginFrozenIdx === -1) {
      return 0;
    }

    const marginFrozenValue = calculateActualQuarterTotal(rowArr[rIdx].measures[marginFrozenIdx].quarters[qIdx].weeks);
    const planQuotaFrozenValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters[qIdx].weeks);

    if (planQuotaFrozenValue === 0) {
      return 0;
    }
    return OneDecimalPlace((marginFrozenValue / planQuotaFrozenValue) * 100);
  }

  if (measureName === 'LQ Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ Margin $');
    const lqActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');

    if (lqMarginIdx === -1 || lqActualIdx === -1) {
      return 0;
    }

    const lqMarginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lqMarginIdx].quarters[qIdx].weeks);
    const lqActualValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[lqActualIdx].quarters[qIdx].weeks);

    if (lqActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace((lqMarginValue / lqActualValue) * 100);
  }

  if (measureName === 'LY Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY Margin $');
    const lyActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (lyMarginIdx === -1 || lyActualIdx === -1) {
      return 0;
    }

    const lyMarginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lyMarginIdx].quarters[qIdx].weeks);
    const lyActualValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[lyActualIdx].quarters[qIdx].weeks);

    if (lyActualValue === 0) {
      return 0;
    }
    return OneDecimalPlace((lyMarginValue / lyActualValue) * 100);
  }

  if (measureName === 'PL vs LQ Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const marginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters[qIdx].weeks);

    const marginPctValue = Math.round((marginValue / planQuotaValue) * 100);

    const lqMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LQ Margin $');
    const lqActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LQ - Actuals $');

    if (lqMarginIdx === -1 || lqActualIdx === -1) {
      return 0;
    }

    const lqMarginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lqMarginIdx].quarters[qIdx].weeks);
    const lqActualValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[lqActualIdx].quarters[qIdx].weeks);

    const lqMarginPctValue = Math.round((lqMarginValue / lqActualValue) * 100);

    if (planQuotaValue === 0 || lqActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace(marginPctValue - lqMarginPctValue);
  }

  if (measureName === 'PL vs LY Margin %') {
    const rowIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'Margin $');
    const planQuotaIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'Plan / Quota Sales $');

    if (marginIdx === -1 || planQuotaIdx === -1) {
      return 0;
    }

    const marginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[marginIdx].quarters[qIdx].weeks);
    const planQuotaValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[planQuotaIdx].quarters[qIdx].weeks);

    const marginPctValue = Math.round((marginValue / planQuotaValue) * 100);

    const lyMarginIdx = rowArr[rIdx].measures
      .findIndex((measure) => rowArr[rIdx].name === measureGroup && measure.name === 'LY Margin $');
    const lyActualIdx = rowArr[rowIdx].measures
      .findIndex((measure) => measure.name === 'LY - Actuals $');

    if (lyMarginIdx === -1 || lyActualIdx === -1) {
      return 0;
    }

    const lyMarginValue = calculateActualQuarterTotal(rowArr[rIdx].measures[lyMarginIdx].quarters[qIdx].weeks);
    const lyActualValue = calculateActualQuarterTotal(rowArr[rowIdx].measures[lyActualIdx].quarters[qIdx].weeks);

    const lqMarginPctValue = Math.round((lyMarginValue / lyActualValue) * 100);

    if (planQuotaValue === 0 || lyActualValue === 0) {
      return 0;
    }

    return OneDecimalPlace(marginPctValue - lqMarginPctValue);
  }

  return calculateActualQuarterTotal(rowArr[rIdx].measures[mIdx].quarters[qIdx].weeks);
};

export const calculateActualQuarterTotal = (weekArr): number => {
  const total = weekArr.reduce((wInit, week) => {
    wInit += week.value;
    return wInit;
  }, 0);

  return Math.round(total);
};

export const checkIfAllQuartersArePast = (quarters): boolean => {
  return quarters.reduce((acc, value) => acc && value.isPast, true);
};
